import { CHANNEL_TYPE_ID } from "../../constant/gms-constant";
import { useProposalTypeData } from "../proposal/use-proposal-type-data";
import { useProposalData } from "../populate-data/use-proposal-data";
import { normalizeGroupName } from "../../utils/normalize-group-name.utils";
import { useLazy } from "../services/lazy/use-lazy";
import { useToastify } from "../../library/toastify/toast-provider";
import { useModalAccess } from "../../components/global/modal/use-modal-access";

export const useFirstStepValidation = () => {

    const { showToastNotify } = useToastify();
    const { isUpdateProposal } = useModalAccess();
    const { 
        groupName,
        channelType,
        channelTypeSubName,
        channelTypeNumber,
        channelTypeEmail,
        basicInformation,
        proposalAs,
        hasAffiliation,
        affiliation: affiliations,
        groupClassification,
        othersGroupClassificationValue,
        typeOfGroup,
        othersTypeOfGroupValue,
        typeOfGroupSubType,
        modeOfPayment,
        ageProfile,
        natureOfBusinessItem
    } = useProposalTypeData();
    // const shouldCheckGroupName = !!groupName; 
    const selectedSubTypeIds = typeOfGroupSubType.map(item => item.id);

    const { 
        checkGroupName, 
        existingGroupNameData, 
        isLoadingExistingGroupName, 
        isErrorExistingGroupName, 
        errorExistingGroupName, 
    } = useLazy()
    const { 
        hasOtherSpecifyGC, 
        // hasOtherSpecifyBT, 
        hasOtherToG, 
        isEmployerEmployeeToG, 
        isOFWToG 
    } = useProposalTypeData()
    const { proposal } = useProposalData();
    const currentProposalSECRegName = proposal?.group_name

    const validateChannel = () => {
        if (!channelType || channelType.id === CHANNEL_TYPE_ID.select || channelType.id === null || channelType.name === null) {
            showToastNotify("Please select a channel type.", "warning");
            return false;
        }

        const requiresSubChannel : number[] = [
            CHANNEL_TYPE_ID.broker,
            CHANNEL_TYPE_ID.generalAgency,
            CHANNEL_TYPE_ID.agent,
        ];

        if (requiresSubChannel.includes(channelType.id)) {
            if (!channelTypeSubName?.trim()) {
                showToastNotify(`Please enter the name of ${channelType.name}.`, "warning");
                return false;
            }

            if (!channelTypeNumber) {
                showToastNotify(`Please enter the number of ${channelType.name}.`, "warning");
                return false;
            }

            if (!channelTypeEmail?.trim()) {
                showToastNotify(`Please enter the email of ${channelType.name}.`, "warning");
                return false;
            }

            // Optional email format validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!emailRegex.test(channelTypeEmail.trim())) {
                showToastNotify(`Please enter a valid email address for ${channelType.name}.`, "warning");
                return false;
            }
        }

        return true;
    };

    const validProposalAs = () => {
        if (!proposalAs || proposalAs.id === null || proposalAs.name === null) {
            showToastNotify("Please select a proposal as.", "warning");
            return false;
        }

        // const requiredSecName: number[] = [
        //     PROPOSAL_AS_ID.renew
        // ]

        // if (requiredSecName.includes(proposalAs.id) && !channelSubName) {
        //     showToastNotify(`Please enter name of ${selectedChannelBox.name}.`, "warning");
        //     return false;
        // }

        return true
    }

    const validBasicInformation = () => {
        if (!basicInformation.groupName) {
            showToastNotify("Enter name group/company/organization.", "warning");
            return false;
        }
        // if (!basicInformation.natureOfBusiness) {
        //     showToastNotify("Enter nature of business.", "warning");
        //     return false;
        // }
        if(!natureOfBusinessItem?.name) {
            showToastNotify("Select nature of business.", "warning");
            return false;
        }
        if (!basicInformation.noOfLives) {
            showToastNotify("Enter number of lives.", "warning");
            return false;
        }
        if (!basicInformation.completeBusinessAddress) {
            showToastNotify("Enter complete business address.", "warning");
            return false;
        }
        if (!basicInformation.proposalAddress) {
            showToastNotify("Enter proposal address.", "warning");
            return false;
        }
        if (!basicInformation.addressDesignation) {
            showToastNotify("Enter address designation.", "warning");
            return false;
        }
        // if (!basicInformation.tinNumber || !basicInformation.secNumber) {
        //     showToastNotify("Enter TIN or SEC number.", "warning");
        //     return false;
        // }
        // if (basicInformation.companyMobileNo.length !== 10) {
        //     showToastNotify("Enter valid company mobile number.", "warning");
        //     return false;
        // }
        if (!basicInformation.contactPersonSalutation) {
            showToastNotify("Select salutation.", "warning");
            return false;
        }
        if (!basicInformation.contactPersonFirstName) {
            showToastNotify("Enter first name of contact person.", "warning");
            return false;
        }
        if (!basicInformation.contactPersonMiddleName) {
            showToastNotify("Enter middle initial of contact person.", "warning");
            return false;
        }
        if (basicInformation.contactPersonMiddleName.length > 5) {
            showToastNotify("Middle initial must not exceed 5 characters.", "warning");
            return false;
        }
        if (!basicInformation.contactPersonLastName) {
            showToastNotify("Enter last name of contact person.", "warning");
            return false;
        }
        // if (basicInformation.contactNumber.length !== 10) {
        //     showToastNotify("Enter valid contact number of contact person.", "warning");
        //     return false;
        // }
        if (!basicInformation.email) {
            showToastNotify("Enter email of contact person.", "warning");
            return false;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(basicInformation.email.trim())) {
            showToastNotify("Enter a valid email address.", "warning");
            return false;
        }
        if (!basicInformation.designation) {
            showToastNotify("Enter designation of contact person.", "warning");
            return false;
        }

        return true;
    }

    const validAffiliation = () => {
        if (!hasAffiliation) {
            return true;
        }

        if (affiliations.length === 0) {
            showToastNotify("Please add at least one affiliation.", "warning");
            return false;
        }

        const invalidAffiliation = affiliations.find((item) => !item.name.trim());

        if (invalidAffiliation) {
            const index = affiliations.findIndex((item) => item.id === invalidAffiliation.id);
            
            showToastNotify(`Affiliation #${index + 1}: Please enter the affiliation name.`, "warning");
            return false;
        }

        return true;
    };
    
    const validGroupClassification = () => {
        if (!groupClassification?.id) {
            showToastNotify("Select group classification.", "warning");
            return false;
        }

        if (hasOtherSpecifyGC && !othersGroupClassificationValue) {
            showToastNotify("Please specify the other group classification.", "warning");
            return false;
        }

        return true;
    };

    const validBusinessType = () => {
        // if (!businessType) {
        //     showToastNotify("Select business type.", "warning");
        //     return false;
        // }

        // if (hasOtherSpecifyBT && !otherBusinessType) {
        //     showToastNotify("Please specify the other business type.", "warning");
        //     return false;
        // }

        return true;
    };

    const validTypeOfGroup = () => {
        if (!typeOfGroup?.id) {
            showToastNotify("Select type of group.", "warning");
            return false;
        }

        if(isEmployerEmployeeToG && !selectedSubTypeIds?.length) {
            showToastNotify("Select type of employer-employee.", "warning");
            return false;
        }

        if(isOFWToG && !selectedSubTypeIds?.length) {
            showToastNotify("Select type of OFW.", "warning");
            return false;
        }

        if (hasOtherToG && !othersTypeOfGroupValue) {
            showToastNotify("Please specify the other type of group.", "warning");
            return false;
        }

        return true;
    };

    const validateAge = () => {
        if (!ageProfile || ageProfile.length < 2) {
            showToastNotify("Age profile is incomplete.", "warning");
            return false;
        }

        const minAge = ageProfile.find(a => a.label === "Minimum Age")?.age;
        const maxAge = ageProfile.find(a => a.label === "Max Age")?.age;

        if (minAge == null || maxAge == null) {
            showToastNotify("Age profile is invalid.", "warning");
            return false;
        }

        if (minAge < 18) {
            showToastNotify("Minimum age must be at least 18.", "warning");
            return false;
        }

        if (maxAge > 65) {
            showToastNotify("Maximum age cannot exceed 65.", "warning");
            return false;
        }

        if (minAge > maxAge) {
            showToastNotify("Minimum age cannot be greater than maximum age.", "warning");
            return false;
        }

        return true;
    };

    const validModeOfPayment = () => {
        if (!modeOfPayment?.id) {
            showToastNotify("Select mode of payment.", "warning");
            return false;
        }

        return true
    }

    const validGroupName = async (): Promise<boolean> => {
        if(!groupName) return false

        const isSameGroupName = normalizeGroupName(groupName) === normalizeGroupName(currentProposalSECRegName);

        if (isUpdateProposal && isSameGroupName) {
            return true;
        }

        try {
            const result = await checkGroupName({ groupName }).unwrap();

            if (result.data.exists) {
                showToastNotify(result.message, "warning");
                return false;
            }

            return true;
        } catch (error: any) {
            showToastNotify(error?.data?.message || "Error checking group name", "warning");
            return false;
        }
    };

    return { 
        validBasicInformation,
        validAffiliation, 
        validateChannel, 
        validProposalAs,
        validGroupClassification,
        validBusinessType,
        validTypeOfGroup,
        validateAge,
        validModeOfPayment,
        validGroupName,

        checkGroupName,
        existingGroupNameData,
        isLoadingExistingGroupName,
        isErrorExistingGroupName,
        errorExistingGroupName,
    };
};